import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaGithub, FaFileAlt } from 'react-icons/fa';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-gray-100 dark:bg-gray-800">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="section-title">Connect with Me</h2>

          <div className="flex justify-center items-center mt-10 space-x-8">
            {/* LinkedIn Link */}
            <a
              href="https://www.linkedin.com/in/sebasti%C3%A1n-glonek-208852216/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-3xl text-gray-600 dark:text-gray-300 hover:text-blue-500 dark:hover:text-blue-400 transition-colors duration-300"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>

            {/* Resume Link */}
            <a
              href="/Resume.pdf" // Path to your resume in the public folder
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-full transition-colors duration-300"
              aria-label="View Resume"
            >
              <FaFileAlt className="inline-block mr-2" /> View My Resume
            </a>

            {/* GitHub Link */}
            <a
              href="https://github.com/De-Fo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-3xl text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 transition-colors duration-300"
              aria-label="GitHub"
            >
              <FaGithub />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;